module.exports = [
	{
		"fund_family_label": "Vanguard",
		"as_of": "202508",
		"fund_id": 191,
		"net_asset_sum": 10149876229236,
		"long_asset_sum": 10334895119686,
		"num_equity_funds": 103,
		"equity_fund_net_assets": 7442177569605,
		"equity_fund_long_assets": 7446035458742,
		"num_e_sri": 6,
		"num_e_usf": 0,
		"sri_long_assets": 41953333929,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 41087618416,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 541,
		"df_producer_asset_sum": 23517915856,
		"df_financier_count_sum": 397,
		"df_financier_asset_sum": 197573130951,
		"df_consumer_count_sum": 2036,
		"df_consumer_asset_sum": 651144284398,
		"df_all_count_sum": 2785,
		"df_all_asset_sum": 859980901164,
		"df_all_weight_total": 0.11549513911518397,
		"climate_asset_sum": 608836407458,
		"ff_all_asset_sum": 593353578228,
		"sri_climate_asset_sum": 310889030,
		"sri_with_most_climate_asset": 143717460,
		"name": "Vanguard",
		"fund_family_name": "Vanguard",
		"label": "Vanguard"
	},
	{
		"fund_family_label": "BlackRock/iShares",
		"as_of": "202508",
		"fund_id": 601,
		"net_asset_sum": 4038811423504,
		"long_asset_sum": 4242267434742,
		"num_equity_funds": 316,
		"equity_fund_net_assets": 2760421998617,
		"equity_fund_long_assets": 2771826762877,
		"num_e_sri": 35,
		"num_e_usf": 0,
		"sri_long_assets": 61666793798,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 53269562966,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 933,
		"df_producer_asset_sum": 12041077361,
		"df_financier_count_sum": 920,
		"df_financier_asset_sum": 80105669382,
		"df_consumer_count_sum": 3827,
		"df_consumer_asset_sum": 220620860159,
		"df_all_count_sum": 5342,
		"df_all_asset_sum": 307333771324,
		"df_all_weight_total": 0.11087769821697113,
		"climate_asset_sum": 242913933029,
		"ff_all_asset_sum": 236346898964,
		"sri_climate_asset_sum": 3560175616,
		"sri_with_most_climate_asset": 1048307346,
		"name": "BlackRock/iShares",
		"fund_family_name": "BlackRock/iShares",
		"label": "BlackRock/iShares"
	},
	{
		"fund_family_label": "American Funds/Capital Group",
		"as_of": "202508",
		"fund_id": 98,
		"net_asset_sum": 3046131836035,
		"long_asset_sum": 3063167338825,
		"num_equity_funds": 37,
		"equity_fund_net_assets": 2277578589245,
		"equity_fund_long_assets": 2281937500240,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 68,
		"df_producer_asset_sum": 9855403913,
		"df_financier_count_sum": 151,
		"df_financier_asset_sum": 55934931317,
		"df_consumer_count_sum": 406,
		"df_consumer_asset_sum": 138933616006,
		"df_all_count_sum": 604,
		"df_all_asset_sum": 202309126602,
		"df_all_weight_total": 0.08865673427984876,
		"climate_asset_sum": 157968219332,
		"ff_all_asset_sum": 152278962520,
		"sri_climate_asset_sum": 0,
		"sri_with_most_climate_asset": 0,
		"name": "American Funds/Capital Group",
		"fund_family_name": "American Funds/Capital Group",
		"label": "American Funds/Capital Group"
	},
	{
		"fund_family_label": "Fidelity Investments",
		"as_of": "202508",
		"fund_id": 544,
		"net_asset_sum": 4249800613526,
		"long_asset_sum": 4301005578816,
		"num_equity_funds": 300,
		"equity_fund_net_assets": 2868432791915,
		"equity_fund_long_assets": 2873896363095,
		"num_e_sri": 21,
		"num_e_usf": 0,
		"sri_long_assets": 8396115462,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 7207449534,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 667,
		"df_producer_asset_sum": 7578145483,
		"df_financier_count_sum": 773,
		"df_financier_asset_sum": 61855111114,
		"df_consumer_count_sum": 3288,
		"df_consumer_asset_sum": 235163811405,
		"df_all_count_sum": 4490,
		"df_all_asset_sum": 301488938259,
		"df_all_weight_total": 0.10490598830582602,
		"climate_asset_sum": 214310378909,
		"ff_all_asset_sum": 209933161346,
		"sri_climate_asset_sum": 277932299,
		"sri_with_most_climate_asset": 112717466,
		"name": "Fidelity Investments",
		"fund_family_name": "Fidelity Investments",
		"label": "Fidelity Investments"
	},
	{
		"fund_family_label": "State Street",
		"as_of": "202508",
		"fund_id": 171,
		"net_asset_sum": 1636067396707,
		"long_asset_sum": 1636111493617,
		"num_equity_funds": 94,
		"equity_fund_net_assets": 1346452453548,
		"equity_fund_long_assets": 1346454928718,
		"num_e_sri": 6,
		"num_e_usf": 0,
		"sri_long_assets": 1733360258,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 1720586542,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 368,
		"df_producer_asset_sum": 3762177416,
		"df_financier_count_sum": 298,
		"df_financier_asset_sum": 37214218187,
		"df_consumer_count_sum": 1361,
		"df_consumer_asset_sum": 134282445500,
		"df_all_count_sum": 1884,
		"df_all_asset_sum": 172767065382,
		"df_all_weight_total": 0.12831255001346142,
		"climate_asset_sum": 145241095690,
		"ff_all_asset_sum": 141937179611,
		"sri_climate_asset_sum": 101354002,
		"sri_with_most_climate_asset": 51702305,
		"name": "State Street",
		"fund_family_name": "State Street",
		"label": "State Street"
	},
	{
		"fund_family_label": "Schwab Funds",
		"as_of": "202508",
		"fund_id": 95,
		"net_asset_sum": 692128904802,
		"long_asset_sum": 692221680993,
		"num_equity_funds": 43,
		"equity_fund_net_assets": 600375805958,
		"equity_fund_long_assets": 600381461563,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 219,
		"df_producer_asset_sum": 3398208369,
		"df_financier_count_sum": 177,
		"df_financier_asset_sum": 15149476886,
		"df_consumer_count_sum": 1064,
		"df_consumer_asset_sum": 57140320933,
		"df_all_count_sum": 1366,
		"df_all_asset_sum": 73791108945,
		"df_all_weight_total": 0.12290704105502574,
		"climate_asset_sum": 61714416044,
		"ff_all_asset_sum": 59616016814,
		"sri_climate_asset_sum": 0,
		"sri_with_most_climate_asset": 0,
		"name": "Schwab Funds",
		"fund_family_name": "Schwab Funds",
		"label": "Schwab Funds"
	},
	{
		"fund_family_label": "Dimensional Fund Advisors",
		"as_of": "202508",
		"fund_id": 144,
		"net_asset_sum": 671496194451,
		"long_asset_sum": 678575754068,
		"num_equity_funds": 78,
		"equity_fund_net_assets": 545835360946,
		"equity_fund_long_assets": 546345394937,
		"num_e_sri": 7,
		"num_e_usf": 0,
		"sri_long_assets": 17996710155,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 16181739027,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 1325,
		"df_producer_asset_sum": 3027338235,
		"df_financier_count_sum": 628,
		"df_financier_asset_sum": 14767992721,
		"df_consumer_count_sum": 2353,
		"df_consumer_asset_sum": 31941983775,
		"df_all_count_sum": 4014,
		"df_all_asset_sum": 48435089139,
		"df_all_weight_total": 0.08865287341643124,
		"climate_asset_sum": 53169552434,
		"ff_all_asset_sum": 50983005407,
		"sri_climate_asset_sum": 582892433,
		"sri_with_most_climate_asset": 214281943,
		"name": "Dimensional Fund Advisors",
		"fund_family_name": "Dimensional Fund Advisors",
		"label": "Dimensional Fund Advisors"
	},
	{
		"fund_family_label": "T. Rowe Price",
		"as_of": "202508",
		"fund_id": 182,
		"net_asset_sum": 943027540464,
		"long_asset_sum": 949209620433,
		"num_equity_funds": 79,
		"equity_fund_net_assets": 630623165421,
		"equity_fund_long_assets": 631353062452,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 25978647,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 25978647,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 100,
		"df_producer_asset_sum": 2160222938,
		"df_financier_count_sum": 208,
		"df_financier_asset_sum": 11830372884,
		"df_consumer_count_sum": 653,
		"df_consumer_asset_sum": 40449739253,
		"df_all_count_sum": 916,
		"df_all_asset_sum": 53796650250,
		"df_all_weight_total": 0.08520850447936175,
		"climate_asset_sum": 42746593160,
		"ff_all_asset_sum": 40923731627,
		"sri_climate_asset_sum": 727058,
		"sri_with_most_climate_asset": 727058,
		"name": "T. Rowe Price",
		"fund_family_name": "T. Rowe Price",
		"label": "T. Rowe Price"
	},
	{
		"fund_family_label": "TIAA Investments/Nuveen",
		"as_of": "202508",
		"fund_id": 164,
		"net_asset_sum": 685029751859,
		"long_asset_sum": 686139115752,
		"num_equity_funds": 61,
		"equity_fund_net_assets": 447202329455,
		"equity_fund_long_assets": 447217969323,
		"num_e_sri": 15,
		"num_e_usf": 1,
		"sri_long_assets": 44180819441,
		"usf_long_assets": 12978575094,
		"equity_fund_sri_long_assets": 36901890719,
		"equity_fund_usf_long_assets": 6493762965,
		"sustainable_manager": 0,
		"df_producer_count_sum": 198,
		"df_producer_asset_sum": 1635504092,
		"df_financier_count_sum": 180,
		"df_financier_asset_sum": 12753276104,
		"df_consumer_count_sum": 792,
		"df_consumer_asset_sum": 42139565480,
		"df_all_count_sum": 1107,
		"df_all_asset_sum": 55960929727,
		"df_all_weight_total": 0.12513121914961028,
		"climate_asset_sum": 32802009510,
		"ff_all_asset_sum": 32184654449,
		"sri_climate_asset_sum": 1135970774,
		"sri_with_most_climate_asset": 448330050,
		"name": "TIAA Investments/Nuveen",
		"fund_family_name": "TIAA Investments/Nuveen",
		"label": "TIAA Investments/Nuveen"
	},
	{
		"fund_family_label": "Invesco",
		"as_of": "202508",
		"fund_id": 336,
		"net_asset_sum": 1073454184113,
		"long_asset_sum": 1094107124541,
		"num_equity_funds": 202,
		"equity_fund_net_assets": 837387696801,
		"equity_fund_long_assets": 839735546580,
		"num_e_sri": 14,
		"num_e_usf": 0,
		"sri_long_assets": 10483390744,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 7912529935,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 204,
		"df_producer_asset_sum": 1485753056,
		"df_financier_count_sum": 279,
		"df_financier_asset_sum": 8664777594,
		"df_consumer_count_sum": 1368,
		"df_consumer_asset_sum": 78808314335,
		"df_all_count_sum": 1746,
		"df_all_asset_sum": 87891909618,
		"df_all_weight_total": 0.1046661773173213,
		"climate_asset_sum": 54533252339,
		"ff_all_asset_sum": 53116671234,
		"sri_climate_asset_sum": 301871707,
		"sri_with_most_climate_asset": 181158981,
		"name": "Invesco",
		"fund_family_name": "Invesco",
		"label": "Invesco"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/FamilyFunds.json
// module id = 949
// module chunks = 0